const errorMessage_en = {
	defaultErrorMsg: 'defaultErrorMsg',
	OIM0056: 'OIM0056 message'
};

export default errorMessage_en;
